import React, { useState } from 'react';
import DataSyncSection from './DataSyncSection';
import ServiceTypesSection from './ServiceTypesSection';
import ChecklistSection from './ChecklistSection';
import JobSettingsSection from './JobSettingsSection';
import NotificationsSection from '../NotificationsSection';
import DeveloperToolsSection from './DeveloperToolsSection';
import StreamlineApiSection from './StreamlineApiSection';
import QuickBooksApiSection from './QuickBooksApiSection';
import HelpTutorialsSection from './HelpTutorialsSection';
import JobFlagsSection from './JobFlagsSection';
import WorkOrderFlagsSection from './WorkOrderFlagsSection';
import GPSSettingsSection from './GPSSettingsSection';
import GuestAppSettingsSection from './GuestAppSettingsSection';
import PrivilegesSection from './PrivilegesSection';
import TimeClockSettingsSection from './TimeClockSettingsSection';
import DatabaseSafetySection from './DatabaseSafetySection';

function SettingsTabs({ refetchJobs, userRole }) {
  const [activeTab, setActiveTab] = useState('data-sync');
  
  const tabs = [
    { id: 'data-sync', name: 'Manual Data Sync', component: <DataSyncSection refetchJobs={refetchJobs} /> },
    { id: 'job-settings', name: 'Auto-Sync Data', component: <JobSettingsSection /> },
    { id: 'streamline-api', name: 'Streamline API', component: <StreamlineApiSection /> },
    { id: 'quickbooks-api', name: 'QuickBooks', component: <QuickBooksApiSection /> },
    { id: 'gps', name: 'GPS', component: <GPSSettingsSection /> },
    { id: 'timeclock', name: 'Timeclock', component: <TimeClockSettingsSection /> },
    { id: 'service-types', name: 'Service Types', component: <ServiceTypesSection /> },
    { id: 'checklists', name: 'Checklists', component: <ChecklistSection /> },
    { id: 'job-flags', name: 'Job Flags', component: <JobFlagsSection /> },
    { id: 'work-order-flags', name: 'Work Order Flags', component: <WorkOrderFlagsSection /> },
    { id: 'notifications', name: 'Notifications', component: <NotificationsSection /> },
    { id: 'guest-app', name: 'Guest App', component: <GuestAppSettingsSection /> },
    { id: 'privileges', name: 'Privileges', component: <PrivilegesSection /> },
    { id: 'help-tutorials', name: 'Help Tutorials', component: <HelpTutorialsSection /> },
    { id: 'database-safety', name: 'Database Safety', component: <DatabaseSafetySection /> },
    { id: 'developer', name: 'Developer Tools', component: <DeveloperToolsSection /> },
  ];

  return (
    <div>
      {/* Mobile dropdown for very small screens */}
      <div className="sm:hidden mb-4">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-sky-500 focus:outline-none focus:ring-sky-500"
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>

      {/* Horizontal scrollable tabs for larger screens */}
      <div className="hidden sm:block border-b border-gray-200">
        <nav className="-mb-px flex space-x-4 lg:space-x-8 overflow-x-auto scrollbar-hide" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-2 lg:px-1 border-b-2 font-medium text-sm flex-shrink-0
                ${activeTab === tab.id
                  ? 'border-sky-500 text-sky-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `}
              aria-current={activeTab === tab.id ? 'page' : undefined}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>
      
      <div className="mt-4 sm:mt-6">
        {tabs.find(tab => tab.id === activeTab)?.component}
      </div>
    </div>
  );
}

export default SettingsTabs;
